module.exports = __webpack_public_path__ + "static/apple_store_badge-af1c0e8f55caf21d8e0fd1c80015695f.svg";